import { Prices } from '~/types'

export const mkPrices = (price: number): Prices => {
  return {
    partial: {
      value: price * (1 - window.htcConfig.payment.down_payment_percentage / 100),
      label: (price * (1 - window.htcConfig.payment.down_payment_percentage / 100)).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    skonto: {
      value: price * (1 - window.htcConfig.payment.skonto_percentage / 100),
      label: (price * (1 - window.htcConfig.payment.skonto_percentage / 100)).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    full: { value: price, label: price.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  }
}
